import React from 'react';
import PropTypes from 'prop-types';
import TaxDiagnosticMessagePicker from './TaxDiagnosticMessagePicker/TaxDiagnosticMessagePicker';

const TaxDiagnosticMessageContent = ({
  messageResource,
}) => {
  return (
    <TaxDiagnosticMessagePicker resource={messageResource} />
  );
};

TaxDiagnosticMessageContent.defaultProps = {
};

TaxDiagnosticMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
};


export default TaxDiagnosticMessageContent;
